import {
  contentTypeParser,
  supportsGalleryPreview,
} from "../utilities/contentTypeParser";
import type { Attachment } from "./types";

export const useAttachment = (attachment: Attachment) => {
  const isImage = contentTypeParser.isImage(attachment.content_type);
  const isVoiceMessage = Boolean(attachment.metadata?.voice_message);
  const isVideo =
    !isVoiceMessage &&
    contentTypeParser.isNativelySupportedVideo(attachment.content_type);

  const doesAttachmentSupportGalleryPreview =
    !isVoiceMessage && supportsGalleryPreview(attachment.content_type);

  const isPDF = contentTypeParser.isPDF(attachment.content_type);
  const isImageOrVideo = isImage || isVideo;

  return {
    isImage,
    isVoiceMessage,
    isVideo,
    doesAttachmentSupportGalleryPreview,
    isImageOrVideo,
    isPDF,
  };
};
